document.querySelectorAll("section.c-section a.c-button").forEach(item => {
    item.addEventListener("click", (e) => {
      if (item.href.includes('scrollToSection')) {
        // console.log(item.href);
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        let myVar = item.href.split('=')[1];
        // console.log(myVar);
        location.href = "#" + item.closest("main").childNodes[myVar].id;
      }
    });
  });